export function KeyboardWindowsIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.66666" y="3.66663" width="4" height="4" fill="currentColor" />
      <rect x="6.33334" y="3.66663" width="4" height="4" fill="currentColor" />
      <rect x="1.66666" y="8.33337" width="4" height="4" fill="currentColor" />
      <rect x="6.33334" y="8.33337" width="4" height="4" fill="currentColor" />
    </svg>
  );
}
